import { Box, Chip, Stack, Tooltip, Typography } from "@mui/material";
import {
  describeStrugglingFlag,
  LearnerStrugglingSummary,
  STRUGGLING_REASON,
} from "helpers/strugglingLearner";
import { MouseEvent, useState } from "react";
import { UnderperformingDetailModal } from "./UnderperformingDetailModal";

const performanceFlags = (summary?: LearnerStrugglingSummary) =>
  (summary?.flags || []).filter(
    (flag) => flag.reasonCode !== STRUGGLING_REASON.THIN_DATA,
  );

export const StrugglingFlagChip = ({
  summary,
  showReasons = false,
  orgId,
}: {
  summary?: LearnerStrugglingSummary;
  showReasons?: boolean;
  orgId?: string;
}) => {
  const [open, setOpen] = useState(false);
  const reasons = performanceFlags(summary).map(describeStrugglingFlag);
  const thinFlag = summary?.flags.find(
    (flag) => flag.reasonCode === STRUGGLING_REASON.THIN_DATA,
  );
  const tooltip = reasons.length
    ? reasons.join("\n")
    : thinFlag
      ? describeStrugglingFlag(thinFlag)
      : "No underperformance flags from completed feedback.";

  const openDetails = (event: MouseEvent) => {
    event.stopPropagation();
    event.preventDefault();
    setOpen(true);
  };

  const chip = (
    <Tooltip title={<Box sx={{ whiteSpace: "pre-line" }}>{tooltip}</Box>}>
      <Chip
        size="small"
        color={summary?.escalated ? "error" : "warning"}
        label="Underperforming"
        clickable={Boolean(orgId)}
        onClick={orgId ? openDetails : undefined}
        sx={{ width: "fit-content" }}
      />
    </Tooltip>
  );

  if (summary?.isStruggling) {
    return (
      <>
        <Stack spacing={0.5} alignItems="flex-start" sx={{ maxWidth: 360 }}>
          {chip}
          {reasons.map((reason) => (
            <Typography
              key={reason}
              variant="body2"
              color="text.secondary"
              sx={
                showReasons
                  ? undefined
                  : { display: { xs: "block", md: "none" } }
              }
            >
              {reason}
            </Typography>
          ))}
        </Stack>
        {orgId && (
          <UnderperformingDetailModal
            open={open}
            onClose={() => setOpen(false)}
            orgId={orgId}
            summary={summary}
          />
        )}
      </>
    );
  }

  return (
    <Tooltip title={tooltip}>
      <Chip size="small" color="success" variant="outlined" label="On track" />
    </Tooltip>
  );
};
